import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import _ from "lodash"

import { useUser, useLang, useMenu, useLoading } from "../zustand/store.js";

import { TableVirtuoso, Virtuoso } from 'react-virtuoso';
import { toast } from 'react-toastify';

import routes from "../libs/routes";
import images from "../libs/images";
import consts from "../libs/consts";

import { numFormat, errorMessage, elapsedTime } from "../utils/utils";
import * as APIS from "../utils/service";

import Button from '../components/Button';


import { ContentTypeText, LangText } from "../zustand/dict.js";
import { useLocation, useNavigate } from "react-router-dom";
import TagBox from "../components/TagBox.js";
import ArtDetailPopup from "../components/ArtDetailPopup.js";
import { makeOptionList } from "../libs/makeOption.js";
import Modal from "../components/Modal.js";

// import { lang } from '../utils/utils';

export default function ArtHistory() {

    const navigate = useNavigate();
    const location = useLocation();

    const { menu, getMenu } = useMenu();
    const { lang, country, getLang } = useLang()
    const { setLoading } = useLoading()

    const ref = useRef(null);

    const [list, setlist] = useState([]);
    const [viewlist, setviewlist] = useState([]);
    const [pagerows, setpagerows] = useState(20);

    const [stx, setstx] = useState('');
    const [load, setLoad] = useState(true);

    const [photoIndex, setPhotoIndex] = useState(0);
    const [photoInfo, setPhotoInfo] = useState(null);
    const [detailOpen, setDetailOpen] = useState(false);

    const [focusIndex, setFocusIndex] = useState(null);

    useEffect(() => {
        dataFunc();
    }, []);

    useEffect(() => {
        if (list?.length > 0) {
            setviewlist(
                list?.filter(filterFunc),
            )
        } else {
            setviewlist([]);
        }
    }, [
        list,
        stx
    ]);

    const makeOptionData = (artData) => {
        let settingData = [];
        if (artData.styleStrength) {
            settingData.push("Style Strength " + artData.styleStrength)
        }

        if (artData.contentType) {
            settingData.push(<ContentTypeText value={artData.contentType} />)
        }
        if (artData.imageStyle) {
            settingData.push("Style " + artData.imageStyle)
        }
        settingData.push(artData.share ? "Share" : "Private");

        if (artData.width && artData.height) {
            function gcd(a, b) {
                return b === 0 ? a : gcd(b, a % b);
            }

            function calculateAspectRatio(width, height) {
                const divisor = gcd(width, height);
                const aspectWidth = width / divisor;
                const aspectHeight = height / divisor;

                return `${aspectWidth}:${aspectHeight}`;
            }

            settingData.push(calculateAspectRatio(artData.width, artData.height))
        }

        if (artData.seed) {
            settingData.push("Seed " + artData.seed)
        }

        return settingData
    }

    const dataFunc = () => {
        // setlist(new Array(120).fill({}));
        setLoading(true);
        APIS.post("/user/myArt", {}).then(({ data }) => {
            console.log("🚀 ~ APIS.post ~ data:", data)
            setlist(data);


            // setTimeout(() => {

            // }, 3000)
            setTimeout(() => {
                setLoading(false);
                if (location.state) {
                    console.log("🚀 ~ APIS.post ~ location.state:", location.state)
                    let findIdx = location.state?.artIdx;
                    let findIndex = data.findIndex((v) => v.idx == findIdx)
                    console.log("🚀 ~ APIS.post ~ findIndex:", findIndex)

                    if (findIndex > 0) {
                        ref.current.scrollToIndex({
                            index: findIndex - 1
                        })
                    }

                    setFocusIndex(findIndex);
                    setTimeout(() => {
                        setFocusIndex(null);
                    }, 1000)
                }
            }, 200)
        }).catch(e => {
            setLoading(false);
        })
    }

    const [deleteItem, setDeleteItem] = useState(null)
    const deleteFunc = (type, idx) => {
        if (type != "image" && type != "video") {
            console.log("Invalid type");
            return;
        }

        if (typeof idx != "number") {
            console.log("Invalid idx");
            return
        }
        setDeleteItem({ type: type, idx: idx })
        setModal({
            ...modal,
            open: true,
            type: "delete",
            message: getLang({ key: "info_item_delete" }),
            isClose: true
        })
    }

    const filterFunc = (item) => {
        return true
    }

    const pageFunc = (item, index) => {
        // return (
        //     index <= pagerows
        // )
        return true
    }

    const loadMore = () => {
        // 추가 로드
    }

    const isMobileSize = () => {
        return window.innerWidth <= consts.mobileWidth;
    }

    function imageDownFunc(url, ext = "png") {
        setLoading(true)
        fetch(url, {
            method: "GET",
            headers: {}
        })
            .then(response => {
                response.arrayBuffer().then(function (buffer) {
                    setLoading(false)
                    const url = window.URL.createObjectURL(new Blob([buffer]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "download." + ext); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                }).catch(e => {
                    setLoading(false)
                });
            })
            .catch(err => {
                setLoading(false)
                console.log(err);
            });
    }

    function reWorkFunc(menuId, data) {
        console.log("menuId", menuId)
        if (menuId == 1) navigate(routes.menu_1, { state: { artData: data } })
        if (menuId == 2) navigate(routes.menu_2, { state: { artData: data } })
        if (menuId == 3) navigate(routes.menu_3, { state: { artData: data } })
        if (menuId == 4) navigate(routes.menu_4, { state: { artData: data } })
        if (menuId == 6) navigate(routes.menu_6, { state: { artData: data } })

        if (menuId == 7) navigate(routes.menu_7, { state: { artData: data } })
        if (menuId == 8) navigate(routes.menu_8, { state: { artData: data } })
        if (menuId == 9) navigate(routes.menu_9, { state: { artData: data } })
        if (menuId == 10) navigate(routes.menu_10, { state: { artData: data } })
    }

    const [refundData, setRefundData] = useState(null);
    function reRefundFunc(data) {
        setRefundData(data)
        setModal({
            ...modal,
            open: true,
            type: "refund",
            message: getLang({ key: "info_item_refund" }),
            isClose: true
        })
    }

    const [modal, setModal] = useState(consts.defaultModalValue)

    const modalConfirm = () => {
        if (modal.type === "delete") {
            if (deleteItem) {
                APIS.post("/user/myArtDelete", {
                    type: deleteItem.type,
                    artIdx: deleteItem.idx
                }).then(({ data }) => {
                    setDeleteItem(null)
                    dataFunc();
                }).catch(e => {
                    setLoading(false);
                })
            }
            modalClose();
        } else if (modal.type === "refund") {
            APIS.post("/user/myArtRefund", {
                type: refundData.type,
                menuId: refundData.menuId,
                artIdx: refundData.idx,
            }).then(({ data }) => {
                setRefundData(null)
                dataFunc();
            }).catch(e => {
                setLoading(false);
            })
            modalClose();
        } else {
            modalClose();
        }
    }

    const modalClose = () => {
        setModal(consts.defaultModalValue)
    }

    return (
        <>
            <Modal
                open={modal.open}
                setOpen={(v) => {
                    setModal({ ...modal, open: v })
                }}
                title={modal.title}
                message={modal.message}
                onConfirm={modalConfirm}
                onCancel={modal.isClose ? () => { modalClose(); } : null}
            />

            <div className="content">
                <div className="title_box">
                    <p className="title"><LangText id={"text_show_my_work"} /></p>
                    <p className="sub_title"><LangText id={"info_limitday_down"} /></p>
                </div>

                <div className="my_art_box">
                    <div className="art_tab_box">
                        <div className="tab_item focus" onClick={() => { navigate(routes.myart_history) }}><LangText id={"btn_work_history"} /></div>
                        <div className="tab_item" onClick={() => { navigate(routes.myart_gallery) }}><LangText id={"btn_like"} /></div>
                    </div>

                    <Virtuoso
                        ref={ref}
                        useWindowScroll
                        endReached={() => {
                            loadMore();
                        }}
                        initialTopMostItemIndex={0}
                        data={viewlist?.filter(pageFunc)}
                        itemContent={(index, item) => {
                            return <div className={`my_art_item${focusIndex === index ? " bg_focus" : ""}${index != 0 ? " margint16" : ""}`}>
                                <div className="title_box">
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <span className="title2">{getLang({ key: getMenu({ idx: item?.menuId })?.name_key }) || <LangText id={'menu_name' + item?.menuId} />}</span>
                                        {item?.staus == 1 && <span className="caption1 color-sec">
                                            <LangText id={'text_ai_creating'} />
                                        </span>}

                                        {item?.staus >= 2 && <span className="caption1">
                                            {elapsedTime(new Date(item?.createAt).getTime(), country)}
                                        </span>}

                                        {item?.staus == 3 && <span className="caption1 cl_red">
                                            <LangText id={'info_item_refund_don'} />
                                        </span>}

                                        {item?.staus == 9 && <span className="caption1 cl_red">
                                            error
                                        </span>}
                                    </div>
                                    <div className="btn_box">
                                        <Button type={"2 black"} title={<LangText id={'btn_delete'} />} onClick={() => {
                                            let type = item.menuId <= 6 ? "image" : "video"
                                            deleteFunc(type, item.idx)
                                        }} disable={item?.staus == 1} />

                                        {item?.staus == 9 ?
                                            <Button
                                                type={2}
                                                title={<LangText id={'btn_error_refund'} />}
                                                disable={item?.staus == 1}
                                                onClick={() => {
                                                    reRefundFunc(item)
                                                }}
                                            /> :
                                            <Button
                                                type={2}
                                                title={<LangText id={'btn_re_work'} />}
                                                disable={item?.staus == 1}
                                                onClick={() => {
                                                    reWorkFunc(item.menuId, item)
                                                }}
                                            />
                                        }
                                    </div>
                                </div>

                                <div className="info_box margint16">
                                    <div className="text_box">
                                        <p className="text_prompt body1">{item?.prompt}</p>
                                        <TagBox
                                            // list={demoTags[index % 4]}
                                            // list={makeOptionData(item)}
                                            list={makeOptionList(item)}
                                        />
                                    </div>

                                    <div className="img_box">

                                        {item?.type == "image" && item?.files.map((v, i) => {
                                            return <div className="thumb" onClick={() => {
                                                // if (isMobileSize()) {
                                                //     setPhotoInfo(item);
                                                //     setDetailOpen(true);
                                                // }
                                                setPhotoIndex(i)
                                                setPhotoInfo(item);
                                                setDetailOpen(true);
                                            }}>
                                                <img src={consts.imgUrl + v.filePath.replace("file", "thumb")} />
                                                <div className="down_box">
                                                    {/* <a className={`down_btn`} href={consts.imgUrl + v.filePath} download="download.png" /> */}
                                                    <button className={`down_btn`} onClick={(e) => {
                                                        e.stopPropagation();
                                                        imageDownFunc(consts.imgUrl + v.filePath);
                                                    }} />
                                                </div>
                                            </div>
                                        })}

                                        {item?.type == "video" && item?.files.map((v) => {
                                            return <div className="thumb" onClick={() => {
                                                if (isMobileSize()) {
                                                    // setPhotoInfo(item);
                                                    // setDetailOpen(true);
                                                    imageDownFunc(consts.imgUrl + v.filePath, "mp4");
                                                }
                                            }}>
                                                <img src={images.slow_video} style={{ background: "none" }} />
                                                <div className="down_box">
                                                    {/* <a className={`down_btn`} href={consts.imgUrl + v.filePath} download="download.png" /> */}
                                                    <button className={`down_btn`} onClick={() => {
                                                        imageDownFunc(consts.imgUrl + v.filePath, "mp4");
                                                    }} />
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                </div>

                                <div className="bot_btn_box">
                                    <Button type={"2 black"} title={<LangText id={'btn_delete'} />} onClick={() => { }} />
                                    <Button style={{ flex: "auto" }} type={2} title={<LangText id={'btn_re_work'} />} disable={item?.staus == 1}
                                        onClick={() => {
                                            reWorkFunc(item.menuId, item)
                                        }} />
                                </div>
                            </div>
                        }}
                    />
                    {/* {(viewlist?.length > pagerows || load) && (
                        <div className={`table_loading mt-50 ${load ? 'init' : ''}`}>
                            <div className="loading_spin"></div>
                        </div>
                    )} */}
                </div>

                {/* <ArtDetailPopup open={detailOpen} setOpen={setDetailOpen} /> */}
                <ArtDetailPopup
                    open={detailOpen}
                    setOpen={setDetailOpen}
                    data={{
                        menuTitleKey: getMenu({ idx: photoInfo?.menuId })?.title_key,
                        art: photoInfo
                    }}
                    photoIndex={photoIndex}
                    likeClick={() => {
                        setDetailOpen(false)
                    }}
                />
            </div >
        </>
    );
}